/**
 * Export `dimensions`.
 */

export const dimensions = {
  navbarHeight: 80,
  navbarHeightMobile: 64
};
